import React, { useEffect, useState, createContext } from "react";
import Erro from "../pages/Error.js";
import imageManifest from "../assets/data/imageManifest.json";

const Logo = () => {
  const logo = process.env.PUBLIC_URL + "/assets/images/transparente.png";
  return (
    <div className="preloader">
      <img src={logo} alt="Logo" className="preloader-logo" />
    </div>
  );
};

export const InfoContext = createContext(undefined);

const defaultContacts = {
  nome: "Casas do Nabão Lda",
  telefone: "+351 938 873 392",
  email: "geral@casasdonabao.pt",
  morada: "Rua Silva Magalhães, n.º 14, 2300-593 Tomar",
};

export const InfosContextProvider = ({ children }) => {
  const [options, setOptions] = useState({
    transaction: [],
    type: [],
    bedrooms: [],
    bathrooms: [],
    sort: [],
  });
  const [houses, setHouses] = useState([]);
  const [texts, setTexts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [language, setLanguage] = useState("PT");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const textsModule = await import(
          `../assets/data/texts${language}.json`
        );
        const housesModule = await import(
          `../assets/data/properties${language}.json`
        );
        const optionsModule = await import(
          `../assets/data/search${language}.json`
        );

        const textsData = textsModule.default || textsModule;
        const housesData = housesModule.default || housesModule;
        const optionsData = optionsModule.default || optionsModule;
        const housesWithImages = housesData.map((house) => ({
          ...house,
          contacts: house.contacts ?? defaultContacts,
          images: imageManifest[house.imageFolder] ?? [],
        }));

        setTexts(textsData);
        setHouses(housesWithImages);
        setOptions(optionsData);
        setLoading(false);
        setError(false);
      } catch {
        setLoading(false);
        setError(true);
      }
    };

    setLoading(true);
    fetchData();
  }, [language]);

  if (loading) {
    return <Logo />;
  }

  if (error) {
    return <Erro />;
  }

  return (
    <InfoContext.Provider
      value={{ options, houses, texts, language, setLanguage }}
    >
      {children}
    </InfoContext.Provider>
  );
};
